module.exports = __webpack_public_path__ + "img/daeguro_logo.ec71c73d.png";